import React, { Component } from 'react';
import {connect} from 'react-redux';

import * as ActionTypes from '../actions';
import Button from '../components/Button';
import Card from '../components/Card';
import CardTitle from '../components/CardTitle';
import CardText from '../components/CardText';
import Form from '../components/Form';
import Input from '../components/Input';

import ParticipantForm from './ParticipantForm';
import LoadingSpinner from "../components/LoadingSpinner";
import MediaIcon from "../components/MediaIcon";

const mapStateToProps = (state) => {
    return {};
};
const mapDispatchToProps = (dispatch) => {
    return {
        removeParticipantFromItem: (itemIdentifier, identifier) => dispatch(ActionTypes.removeParticipantFromItem(itemIdentifier, identifier))
    };
};

class ParticipantItemEditable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showDetails: false,
            showRemove: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.showSaving == true) {
            this.setState({
                showSaving: false
            })
        }
    }

    handleToggleDetails = event => {
        (event && event.preventDefault());

        this.setState({
            showDetails: ! this.state.showDetails
        });
    }

    handleToggleShowRemove = event => {
        (event && event.preventDefault());

        this.setState({
            showRemove: ! this.state.showRemove
        });
    }

    handleToggleUpdate = event => {
        this.setState({
            showDetails: false,
            showSaving: true
        });
    }

    handleRemoveParticipant = event => {
        event.preventDefault();

        if (this.identifierInput.value && this.itemIdentifierInput.value) {
            this.props.removeParticipantFromItem(this.itemIdentifierInput.value, this.identifierInput.value);
        }
    }

    render() {
        const {identifier, itemIdentifier, item, participant, participantIdentifier} = this.props;
        const {showDetails, showRemove, showSaving} = this.state;

        return (
            <div>
                {showDetails ? (
                    <ParticipantForm item={item} participantIdentifier={participantIdentifier} participant={participant} onSubmit={this.handleToggleUpdate} onDismiss={this.handleToggleDetails} />
                ) : (
                    <Card sm="true" marginBottom="1">
                        <div class="clearfix">
                            {! showDetails && ! showSaving && (
                                <a class="link-reset text-dark o-25 float-right d-inline-block large px-0_5 mr-n0_5" href="#"
                                   onClick={this.handleToggleDetails}>
                                    <i class="fa fa-edit"></i>
                                </a>
                            )}
                            {! showSaving && (
                                <a class="link-reset text-dark o-25 float-right d-inline-block large px-0_5" href="#"
                                   onClick={this.handleToggleShowRemove}>
                                    <i class="fa fa-trash"></i>
                                </a>
                            )}
                            <h5 class="mb-0_25">{participant["PERSON:ANREDE_KURZ"]} {participant["PERSON:TITEL"]} {participant["PERSON:VORNAME"]} {participant["PERSON:NACHNAME"]}</h5>
                        </div>

                        <p class="">
                            {participant["PERSON_ADRESSE:STRASSE:1"]}<br />
                            {participant["PERSON_ADRESSE:PLZ:1"]} {participant["PERSON_ADRESSE:ORT:1"]}
                        </p>

                        {showRemove && (
                            <p class="text-right">
                                <Button type="button" size="sm" theme="outline-danger" onClick={this.handleRemoveParticipant}>Teilnehmer endgültig entfernen</Button>
                                <Button type="button" size="sm" theme="gray" onClick={this.handleToggleShowRemove}>Abbrechen</Button>
                            </p>
                        )}
                        {identifier === 'new' ? (
                            <LoadingSpinner sm="true" />
                        ) : (
                            <div>
                                { ! showDetails && (
                                    <span>
                                        { showSaving && (
                                            <LoadingSpinner sm="true" />
                                        )}
                                    </span>
                                )}
                                <Input inputRef={node => this.itemIdentifierInput = node} type="hidden" value={itemIdentifier} name="itemIdentifier" placeholder="" />
                                <Input inputRef={node => this.identifierInput = node} type="hidden" value={identifier} name="identifier" placeholder="" />
                            </div>
                        )}
                    </Card>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantItemEditable);
